module.exports = __webpack_public_path__ + "img/menu_logo_big.fd722fa.png";